export default __webpack_public_path__ + "static/media/q2_2_step4.83706009.png";